import { render, staticRenderFns } from "./ThemesUsageModal.vue?vue&type=template&id=18829b8a&scoped=true"
import script from "./ThemesUsageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesUsageModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ThemesUsageModal.vue?vue&type=style&index=0&id=18829b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18829b8a",
  null
  
)

export default component.exports